export class RequestConsumerOtpSignUp {
    firstName: string;
    lastName: string;
    email: string;
    mobile: string;
    referral: string;
    otp: string;
    panName: string;
    firebaseToken: string;
}    